import AnnotationBadge from "atoms/badges/annotation-badge";
import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import { ImageAnnotationRecord } from "models/view-models/block-configurations/image-annotation-record";
import { IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME } from "organisms/image-annotations/image-annotation-list";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import React from "react";
import useCurrentPage from "utilities/hooks/domain/notebooks/pages/use-current-page";
import { t } from "utilities/localization-utils";

interface ImageAnnotationListItemProps {
    number: number;
    imageAnnotation: ImageAnnotationRecord;
    onEdit?: (imageAnnotationRecord: ImageAnnotationRecord) => void;
    onDelete?: (imageAnnotationRecord: ImageAnnotationRecord) => void;
    isEditable?: boolean;
}

const ImageAnnotationListItem = (props: ImageAnnotationListItemProps) => {
    const { imageAnnotation, onEdit, onDelete, isEditable, number } = props;
    const { currentPage } = useCurrentPage();
    const { can } = usePageActionPermission(currentPage);
    const canEdit = isEditable && onEdit && can(PageAction.Edit);
    const canDelete = isEditable && onDelete && can(PageAction.Edit);

    const handleEdit = () => {
        canEdit && onEdit(imageAnnotation);
    };
    const handleDelete = () => {
        canDelete && onDelete(imageAnnotation);
    };
    return (
        <li className={`${IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME}__list-item`}>
            <div className={`${IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME}__number`}>
                <AnnotationBadge number={number} />
            </div>
            <span className={`${IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME}__note`}>
                {imageAnnotation.note}
            </span>
            {canEdit && (
                <Button
                    size={ButtonSizes.XSmall}
                    style={ButtonStyles.None}
                    cssClassName={`${IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME}__button -edit`}
                    onClick={handleEdit}>
                    <Icon type={Icons.Edit} size={IconSizes.Small} />
                    <span className="sr-only">
                        {t("editItem", { item: t("imageAnnotation") })}
                    </span>
                </Button>
            )}
            {canDelete && (
                <Button
                    size={ButtonSizes.XSmall}
                    style={ButtonStyles.None}
                    cssClassName={`${IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME}__button -delete`}
                    onClick={handleDelete}>
                    <Icon type={Icons.Trashcan} size={IconSizes.Small} />
                    <span className="sr-only">
                        {t("deleteItem", { item: t("imageAnnotation") })}
                    </span>
                </Button>
            )}
        </li>
    );
};

export default ImageAnnotationListItem;
